import moment from 'moment'
import Vue from 'vue'

Vue.prototype.$moment = moment
